/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CreaTipoPraticaDaTemplateRequestDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TipoPraticaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaDaTemplateRequestParams {
    creaTipoPraticaDaTemplateRequestDTO: CreaTipoPraticaDaTemplateRequestDTO;
}


export interface TipoPraticaDaTemplateServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un TipoPratica da template predefinito (SUPERADMIN)
     * Bootstrap di un nuovo TipoPratica a partire da un template server-side identificato da &#x60;template&#x60; (per ora unico valore: &#x60;MENSA_ESEMPIO&#x60;). Persiste il root e tutti i satelliti strutturali (policy, graduatoria, attributi + valori, gerarchia istituti, eventi/canali comunicazione, configurazione form cittadino) in una singola transazione. Il nuovo TipoPratica e\&#39; sempre creato in stato &#x60;IN_ATTESA&#x60;.  Risposte: - 201: &#x60;TipoPraticaDTO&#x60; del record creato. - 400: payload invalido (template/codice/comune_id mancanti) o comune inesistente. - 403: caller non SUPERADMIN. - 409: codice gia\&#39; usato nel comune target.
     * @endpoint post /api/v1/gestione/tipi-pratica/da-template
* @param requestParameters
     */
    createTipoPraticaDaTemplate(requestParameters: CreateTipoPraticaDaTemplateRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

}
